// src/pages/admin/roles/UpdateRole.tsx
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import RoleForm, { RoleFormData } from "../../../components/admin/roles/RoleForm";
import { useNavigate, useParams } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import { useRolesDetailsByAdmin } from "../../../hooks/admin/roles.admin";
import LoadingErrorState from "../../../components/ui/LoadingErrorState";
import LoadingButton from "../../../components/form/LoadingButton";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";

function AdminUpdateRole() {
  const { roleId} = useParams<{ roleId: string}>();
   const numericRoleId = roleId ? parseInt(roleId) : 0;
  const { register, handleSubmit, reset, formState: { errors },setValue, watch } = useForm<RoleFormData>();


  const {data, isLoading, isError} = useRolesDetailsByAdmin(numericRoleId,false);

  const { loading, updateResource } = useUpdateResource();

  const {t} = useTranslation();
  const navigate = useNavigate();
    
      const onSubmit = (data: RoleFormData) => {
        updateResource(`role/${numericRoleId}`, {name:data.title,permissions:data.permissions},
            "admin",{
                method: "PUT",
                successMessage: t("createdSuccess"),
                invalidateQueries:["roles-by-admin"],
                navigateAfter: () => navigate(`/admin/roles`),
              });
      };

      useEffect(()=>{
        if(data){
          setValue("title",data.name)
          setValue("permissions",data.rolePermissions.map(da=>da.permission))
        }
      },[data,setValue])


  return (
    <div className="p-4">
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
     {
      data &&
       <form onSubmit={handleSubmit(onSubmit)}   className="flex flex-col gap-4 w-full">
        <MainTitle title="update_role_information"/>
        <RoleForm register={register} errors={errors} setValue={setValue} watch={watch}/>
        {
            loading
            ?
            <LoadingButton/>
            :
            <SubmitButton label="update"/>
        }
      </form>
     }
    </div>
  );
}

export default AdminUpdateRole;
